module.exports = __webpack_public_path__ + "img/goal05_over.8b039d6c.png";